<ng-container *ngIf="type=='map'">
  <ng-container *ngFor="let item of dataSource; let i=index">
    <div *ngIf="i==0 && type=='map'" style="text-align: center;">
      <div class="titulo">{{item.extra.titulo}}</div>
      <div class="subtitulo">{{item.extra.subtitulo}}</div>
      <div class="moneda">({{item.extra.moneda}})</div>
    </div>
    <h3>{{item.name|uppercase}}</h3>
  <dx-tree-list
  *ngIf="!showJson2"
                              id="tasks"
                              [dataSource]="item.data"
                              keyExpr="id"
                              parentIdExpr="parent"
                              [columnAutoWidth]="true"
                              [hoverStateEnabled]="true"
                              [autoExpandAll]="true"
                              [wordWrapEnabled]="true"
                              [rowAlternationEnabled]="true"
                              [showBorders]="true">
                              <dxo-scrolling mode="standard"></dxo-scrolling>
                              <dxo-filter-row [visible]="true"></dxo-filter-row>
                              <dxo-paging
                                [enabled]="true"
                                [pageSize]="10">
                              </dxo-paging>
                              <dxo-pager
                                [showPageSizeSelector]="true"
                                [allowedPageSizes]="[5, 10, 20]"
                                [showInfo]="true">
                              </dxo-pager>
                              <dxo-search-panel [visible]="true" placeholder="Buscar..." width="250"></dxo-search-panel>
                              <dxo-selection mode="simple"></dxo-selection>
                              <dxi-column dataField="registro" cellTemplate="accionTemplate" caption="Registro"></dxi-column>
                              <dxi-column dataField="monto_ppto" caption="Presupuesto" dataType="number" alignment="right" [width]="150">
                                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                              </dxi-column>
                              <dxi-column dataField="porc_ppto" caption="% Participación" dataType="number" alignment="right" [width]="150">
                                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                              </dxi-column>
                              <dxi-column dataField="monto_ejec" caption="Ejecución" dataType="number" alignment="right" [width]="130">
                                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                              </dxi-column>
                              <dxi-column dataField="porc_ejec" caption="% Participación" dataType="number" alignment="right" [width]="150">
                                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                              </dxi-column>
                              <dxi-column dataField="porc_div" caption="% Ejec/Presup." dataType="number" alignment="right" [width]="150">
                                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                              </dxi-column>
                              <div *dxTemplate="let data of 'accionTemplate'">
                                <a routerLink="" (click)="open2(data.data)">{{data.data.registro}}</a>
                              </div>
                          </dx-tree-list>
                          <hr>
  </ng-container>
</ng-container>
<ng-container *ngIf="type=='chart'">
  <div style="text-align: center;">
    <div class="titulo">{{names.titulo}}</div>
    <div class="subtitulo">{{names.subtitulo}}</div>
    <div class="moneda">({{names.moneda}})</div>
  </div>
  <dx-tree-list
  *ngIf="!showJson2"
                              id="tasks"
                              [dataSource]="dataSource"
                              keyExpr="id"
                              parentIdExpr="parent"
                              [columnAutoWidth]="true"
                              [hoverStateEnabled]="true"
                              [autoExpandAll]="true"
                              [wordWrapEnabled]="true"
                              [rowAlternationEnabled]="true"
                              [showBorders]="true">
                              <dxo-scrolling mode="standard"></dxo-scrolling>
                              <dxo-filter-row [visible]="true"></dxo-filter-row>
                              <dxo-paging
                                [enabled]="true"
                                [pageSize]="10">
                              </dxo-paging>
                              <dxo-pager
                                [showPageSizeSelector]="true"
                                [allowedPageSizes]="[5, 10, 20]"
                                [showInfo]="true">
                              </dxo-pager>
                              <dxo-search-panel [visible]="true" placeholder="Buscar..." width="250"></dxo-search-panel>
                              <dxo-selection mode="simple"></dxo-selection>
                              <dxi-column dataField="registro" cellTemplate="accionTemplate" caption="Registro"></dxi-column>
                              <dxi-column dataField="monto_ppto" caption="Presupuesto" dataType="number" alignment="right" [width]="130">
                                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                              </dxi-column>
                              <dxi-column dataField="porc_ppto" caption="% Participación" dataType="number" alignment="right" [width]="150">
                                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                              </dxi-column>
                              <dxi-column dataField="monto_ejec" caption="Ejecución" dataType="number" alignment="right" [width]="130">
                                <dxo-format type="fixedPoint" [precision]="0"></dxo-format>
                              </dxi-column>
                              
                              <dxi-column dataField="porc_ejec" caption="% Participación" dataType="number" alignment="right" [width]="150">
                                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                              </dxi-column>
                              <dxi-column dataField="porc_div" caption="% Ejec/Presup." dataType="number" alignment="right" [width]="150">
                                <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                              </dxi-column>
                              <div *dxTemplate="let data of 'accionTemplate'">
                                <a routerLink="" (click)="open2(data.data)">{{data.data.registro}}</a>
                              </div>
                          </dx-tree-list>
                          <hr>
</ng-container>
                        
                        <dx-load-panel
                        #loadPanel
                        shadingColor="rgba(0,0,0,0.4)"
                        message="Cargando..."
                        [(visible)]="loadingVisible"
                        [showIndicator]="true"
                        [showPane]="true"
                        [shading]="true"
                        [closeOnOutsideClick]="false">
                      </dx-load-panel>


// WEBPACK FOOTER //
// ./src/app/pages/report/data-view/data-view.component.html